export default {
  computed: {
    hasInstance() {
      return !!this.integration && this.integration.instance;
    },
    hasSettings() {
      if (this.hasInstance) {
        return !!this.integration.instance.settings;
      }

      return false;
    },
  },
  methods: {
    reEmitLoadingStateChanged(state) {
      this.$emit('loadingStateChanged', state);
    },
  },
};
